import { useCallback, useEffect, useState } from 'react';
import { getCouponStats } from '../services/couponService';

function startOfMonth(date) {
  return new Date(date.getFullYear(), date.getMonth(), 1);
}

function endOfMonth(date) {
  return new Date(date.getFullYear(), date.getMonth() + 1, 0);
}

function toISODate(date) {
  return date.toISOString().slice(0, 10);
}

export function useCouponStats() {
  const now = new Date();
  const [startDate, setStartDate] = useState(toISODate(startOfMonth(now)));
  const [endDate, setEndDate] = useState(toISODate(endOfMonth(now)));
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchStats = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getCouponStats(startDate, endDate);
      setStats(data);
    } catch (err) {
      setStats(null);
    } finally {
      setLoading(false);
    }
  }, [startDate, endDate]);

  useEffect(() => {
    fetchStats();
  }, [fetchStats]);

  return { stats, loading, startDate, endDate, setStartDate, setEndDate, refetch: fetchStats };
}
